import { render, staticRenderFns } from "./SpecificPapaMergeQuestionsActionSelection.vue?vue&type=template&id=d26b0840&scoped=true"
import script from "./SpecificPapaMergeQuestionsActionSelection.vue?vue&type=script&lang=js"
export * from "./SpecificPapaMergeQuestionsActionSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26b0840",
  null
  
)

export default component.exports